import { createStyles } from '@mantine/core'

export default createStyles(() => {
  return {
    root: {
      display: 'flex',
      '.title,.description': {
        color: '#fff',
        textAlign: 'center',
      },
      '.header': {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        marginBottom: 24,
      },
    },
    card: {
      height: '100%',
    },
  }
})
